import { render, staticRenderFns } from "./solutions.vue?vue&type=template&id=70fcea55&scoped=true&"
import script from "./solutions.vue?vue&type=script&lang=js&"
export * from "./solutions.vue?vue&type=script&lang=js&"
import style0 from "./solutions.vue?vue&type=style&index=0&id=70fcea55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fcea55",
  null
  
)

export default component.exports